const FeatureFlagConstants = {
  ZRM_AUTH_0_ENABLED: 'ZRM_AUTH_0_ENABLED',
  ZRM_AUTH_0_MFA_ENABLED: 'ZRM_AUTH_0_MFA_ENABLED',
  ZRM_PROMPT_AUTH_0_MFA_NEW_USERS_ENABLED: 'ZRM_PROMPT_AUTH_0_MFA_NEW_USERS_ENABLED',
} as const;

export default FeatureFlagConstants;
